import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

const defaultValidationFn = value => {
    return !!value;
};

const useInputValidation = props => {

    // Props
    const {validationFn = defaultValidationFn, errMessage = ""} = props || {};

    // i18n
    const {t} = useTranslation();

    // State
    const [value, setValue] = useState("");
    const [isValid, setIsValid] = useState(false);
    const [errorMessage, setErrorMessage] = useState(t("requiredField"));

    useEffect(() => setIsValid(validationFn(value)), [value, validationFn]);
    useEffect(() => errMessage && setErrorMessage(errMessage), [errMessage]);

    return [{value, isValid, errorMessage}, setValue];

};

export default useInputValidation;

